import i18next from "i18next";
import { initReactI18next } from "react-i18next";

i18next.use(initReactI18next).init({
  resources: {
    fa: {
      translation: {
        access: "دسترسی",
        allUsers:'تعداد کاربران',
        allGroups:'تعداد گروه ها',
        allChannels:'تعداد کانال ها',
        addGroup: "افزودن گروه",
        addUser: "افزودن کاربر",
        addItems:"اضافه کردن عضو",
        addAdminsItem:"اضافه کردن ادمین",
        audit: "ممیزی",
        addRole: "افزودن نقش",
        advanceSearch:'جست و جوی پیشرفته',
        reset:"ریست",
        search:'جست و جو',
        addChannel: "افزودن کانال",
        administrator:'سرپرست',
        supervisor:'سوپروایزور',
        basicInformation: "اطلاعات پایه",
        calls: "تماس ها",
        callResult: "نتیجه تماس",
        create: "ایجاد",
        created_at: "ایجاد شده",
        channels: "کانال ها",
        channelsList: "لیست کانال ها",
        channelName: "نام کانال",
        channelDetail:"جزئیات کانال",
        choose:'انتخاب کنید...',
        categories:'دسته ها',
        category:"دسته",
        categoriesList:"لیست دسته ها",
        addCategory:"افزودن دسته",
        removeCategory:"حذف دسته",
        categoryName:'نام دسته',
        admins:"ادمین ها",
        members:"اعضاء",
        conferenceRoom: "اتاق کنفرانس",
        chatGroups: "گروه چت",
        date: "تاریخ",
        dashboard: "داشبورد",
        domain: "دامنه",
        domains: "دامنه ها",
        done: "ذخیره",
        duration: "مدت",
        EditUser: "ویرایش کاربر",
        EditGroup:"ویرایش گروه",
        EditChannel:"ویرایش کانال",
        editCategory:"ویرایش دسته",
        group: "دسته",
        groups: "گروه ها",
        groupsList: "لیست گروه ها",
        GroupAdminsName:"نام ادمین",
        isActive: "فعال",
        active:"فعال",
        deActive:"غیرفعال",
        id: "ردیف",
        isRequired: "این فیلد اجباری است",
        users: "کاربران",
        user: "کاربر",
        usersList: "لیست کاربران",
        userDetail: "جزئیات کاربر",
        userName: "نام کاربری",
        userGroupsName: "نام اعضا",
        update: "به روز رسانی",
        updated_at: "به روز شده",
        role: "نقش",
        rolesList: "لیست نقش ها",
        roleName: "نام نقش",
        roles: "نقش ها",
        room: "اتاق",
        removeItems:"حذف کردن عضو",
        removeRole:'حذف نقش',
        removeAdminsItem:"حذف کردن ادمین",
        firstRole: "نقش اول",
        firstCategory:"دسته اول",
        secondCategory:"دسته دوم",
        secondRole: "نقش دوم",
        statisticReports: "گزارشات آماری",
        sender: "فرستنده",
        webinar: "وبینار",
        operationalAccess: "دسترسی عملیاتی",
        Organization:"سازمان",
        createOperationalAccess: " ایجاد دسترسی عملیاتی",
        orange: "نارنجی",
        onlineUsers:'کاربران آنلاین',
        operation: "عملیات",
        oldPassword: "رمز عبور قدیمی",
        newPassword: "رمز عبور جدید",
        messages: "پیام ها",
        messenger: "پیام رسان",
        mobileNumber: "شماره موبایل",
        MandatoryMembership: "عضویت اجباری",
        mandatory:"اجباری",
        nameAndFamily: "نام و نام خانوادگی",
        reports: "گزارش ها",
        receiver: "گیرنده",
        callsReport: "گزارش تماسها",
        setting: "تنظیمات",
        status: "وضعیت",
        systemName: "نام سیستمی",
        sendCode: "ارسال کد",
        title: "عنوان",
        forgetPassword: "فراموشی رمز عبور",
        firstUser: "کاربر اول",
        secondUser: "کاربر دوم",
        firstEntity: "موجودیت اول",
        secondEntity: "موجودیت دوم",
        themeColor: "رنگ تم",
        hallManager:'مدیر سالن',
        saleManager:'مدیر فروش',
        participants: "اعضا",
        publicSetting: "تنظیمات عمومی",
        purple: "بنفش",
        profile: "پروفایل",
        phoneNumber: "شماره تلفن",
        password: "رمز عبور",
        permissions: "دسترسی ها",
        changePassword: "تغییر رمز عبور",
        createMandantoryMembership: "ایجاد عضویت اجباری",
        CreateOperationalAccess: "ایجاد دسترسی عملیاتی",
        duplicateAdmin:'ادمین تکراری وجود دارد',
        name: "نام",
        yes:"بله",
        no:"خیر",
        edit: "ویرایش",
        editRole:'ویرایش نقش',
        'Mobile number must be a valid Iranian mobile number.':'شماره موبایل را درست وارد کنید',
        'user is exist':'کاربر وجود دارد',
        enter:'وارد کنید',
        exit: "خروج",
        enterAValidMobileNumber:"شماره موبایل صحیح نیست",
        TheNewPasswordThatYouEnteredDoNotMatch:"پسورد وارد شده صحیح نیست",
        youDontHavePermision:"دسترسی ورود ندارید",
        AreYouSureYouWantToDelete:"مطمئنی که میخوای حذفش کنی؟",
        enterFalseValue:"اطلاعات وارد شده اشتباه است",
        export:"دریافت خروجی",
      },
    },
    en: {
      translation: {
        access: "access",
        addGroup: "add group",
        addUser: "add user",
        audit: "audit",
        addRole: "add role",
        addChannel: "add Channel",
        basicInformation: "basic information",
        calls: "calls",
        callResult: "call result",
        create: "create",
        channels: "channels",
        channelName: "channel name",
        conferenceRoom: "conference room",
        callsReport: "call report",
        date: "date",
        dashboard: "dashboard",
        domain: "domain",
        domains: "domains",
        done: "done",
        duration: "duration",
        editUser: "edit user",
        group: "group",
        groups: "groups",
        groupsList: "groups list",
        isActive: "is active",
        id: "id",
        isRequired: "isRequired",
        users: "users",
        user: "user",
        usersList: "users List",
        userDetail: "user detail",
        userName: "userName",
        userGroupsName: "user groups name",
        update: "update",
        role: "role",
        roleName: "role name",
        roles: "roles",
        rolesList: "roles List",
        room: "room",
        firstRole: "first role",
        secondRole: "second role",
        statisticReports: "statistic reports",
        sender: "sender",
        chatGroups: "chat  groups",
        webinar: "webinar",
        operationalAccess: "operational access",
        createOperationalAccess: "create operational access",
        orange: "orange",
        operation: "operation",
        oldPassword: "old password",
        newPassword: "new password",
        forcedAccess: "forced access",
        firstUser: "first user",
        secondUser: "second user",
        firstEntity: "first entity",
        secondEntity: "second entity",
        messages: "messages",
        messenger: "Messenger",
        mobileNumber: "Mobile Number",
        MandatoryMembership: "Mandatory membership",
        nameAndFamily: "Name And Family",
        reports: "reports",
        receiver: "receiver",
        setting: "setting",
        status: "status",
        systemName: "system name",
        sendCode: "send code",
        title: "title",
        forgetPassword: "Forget Password",
        themeColor: "theme",
        participants: "participants",
        publicSetting: "public Setting",
        purple: "purple",
        profile: "profile",
        phoneNumber: "phone number",
        password: "password",
        permissions: "permissions",
        changePassword: "change password",
        createMandantoryMembership: "create mandantory membership",
        CreateOperationalAccess: "create operational access",
        edit: "edit",
        exit: "exit",
        enterAValidMobileNumber:"enter valid mobile number",
        TheNewPasswordThatYouEnteredDoNotMatch:"password is not match",
        youDontHavePermision:"you dont have permision",
        AreYouSureYouWantToDelete:"Are you sure you want to delete",
        export:'export'
      },
    },
  },
  interpolation: {
    escapeValue: false,
  },
});
const i18n = {
  ...i18next,
  isRtl: i18next.dir() === "rtl",
};

export { i18n };
